import React, { useState } from 'react';

/**
 * Password input for password-protected share/public links.
 * Submits with the password; parent re-attempts the redeem call.
 *
 * Props:
 *  - onSubmit(password: string) — fired when user submits a password.
 *  - errorMessage: string?      — last error (e.g. "Wrong password") to show.
 */
function PasswordGate({ onSubmit, errorMessage }) {
    const [pw, setPw] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!pw) return;
        setSubmitting(true);
        try {
            await onSubmit(pw);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="password-gate">
            <div className="password-gate-card">
                <div className="password-gate-title">This link is password protected</div>
                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        autoFocus
                        value={pw}
                        onChange={(e) => setPw(e.target.value)}
                        placeholder="Password"
                        className="password-gate-input"
                    />
                    {errorMessage && (
                        <div className="password-gate-error">{errorMessage}</div>
                    )}
                    <button
                        type="submit"
                        disabled={submitting || !pw}
                        className="password-gate-submit"
                    >
                        {submitting ? "Checking…" : "Open"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default PasswordGate;
